import { useMemo } from 'react';
import { TimesheetLog, TimesheetLogType, UserRole } from '../../../types';
import { calculateDaysBetweenDates } from '../../../utils/formatters';

export interface ApprovalDetailsTableData {
  role: UserRole;
  approver: string;
  dateStart: string;
  dateEnd: string;
  daysPending: number;
  status: TimesheetLogType;
}

export const useApprovalDetailsTableData = (timesheetLogs: TimesheetLog[], cycle: number) => {
  const logs = useMemo(() => {
    if (!timesheetLogs) return;

    const tableData: ApprovalDetailsTableData[] = [];
    timesheetLogs
      .filter((log) => log.cycle === cycle)
      .forEach((log) => {
        tableData.push({
          role: log.role,
          approver: log.createdBy?.name || '',
          dateStart: log.actionStart,
          dateEnd: log.actionEnd,
          daysPending: calculateDaysBetweenDates(log.actionStart, log.actionEnd), 
          status: log.type
        });
      });
    return tableData;
  }, [cycle, timesheetLogs]);
  return logs;
};
